module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "bg"
  }, [_c('img', {
    staticClass: "bg-image",
    attrs: {
      "src": require("../assets/icon/bg_forget.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon/logo.png"),
      "alt": "L"
    },
    on: {
      "click": function($event) {
        return _vm.returnLogin()
      }
    }
  })]), _vm._v(" "), (!_vm.token) ? _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm bg-container",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [(!_vm.isSend) ? _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("忘記密碼 ?")]), _vm._v(" "), _c('h4', {
    staticClass: "hint"
  }, [_vm._v("請輸入您的電子郵件地址以重設密碼。")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkEmail"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "auto-complete": "off",
      "placeholder": "電子郵件"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit($event)
      }
    },
    model: {
      value: (_vm.ruleForm.checkEmail),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "checkEmail", $$v)
      },
      expression: "ruleForm.checkEmail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit($event)
      }
    }
  }, [_vm._v("送出\n            ")])], 1)], 1) : _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("更改密碼")]), _vm._v(" "), _c('h4', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100px",
      "float": "right",
      "margin-top": "20px",
      "margin-bottom": "-20px"
    },
    attrs: {
      "type": "info"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.returnLogin()
      }
    }
  }, [_vm._v("回首頁\n            ")])], 1)], 1)]) : _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checkToken),
      expression: "checkToken"
    }],
    ref: "ruleForm2",
    staticClass: "demo-ruleForm bg-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [(_vm.changeStatus === 0) ? _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("更改密碼")]), _vm._v(" "), _c('div', {
    staticClass: "hint"
  }, [_vm._v("新的密碼")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "newPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPass ? 'text' : 'password',
      "auto-complete": "off",
      "placeholder": "請輸入您要更改的新密碼"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmitPwd($event)
      }
    },
    model: {
      value: (_vm.ruleForm2.newPwd),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "newPwd", $$v)
      },
      expression: "ruleForm2.newPwd"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "20px",
      "height": "20px",
      "right": "1rem",
      "top": "0.5rem",
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.showPass ? '顯示密碼' : '隱藏密碼',
      "src": _vm.showPass ? _vm.openeye : _vm.nopeneye
    },
    on: {
      "click": function($event) {
        _vm.showPass = !_vm.showPass
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "hint"
  }, [_vm._v("再輸入一次")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPass2 ? 'text' : 'password',
      "auto-complete": "off",
      "placeholder": "請再一次輸入，以便確認"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmitPwd($event)
      }
    },
    model: {
      value: (_vm.ruleForm2.checkPwd),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPwd", $$v)
      },
      expression: "ruleForm2.checkPwd"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "20px",
      "height": "20px",
      "right": "1rem",
      "top": "0.5rem",
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.showPass2 ? '顯示密碼' : '隱藏密碼',
      "src": _vm.showPass2 ? _vm.openeye : _vm.nopeneye
    },
    on: {
      "click": function($event) {
        _vm.showPass2 = !_vm.showPass2
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px",
      "margin-bottom": "-20px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmitPwd($event)
      }
    }
  }, [_vm._v("更改\n            ")])], 1)], 1) : (_vm.changeStatus === 1) ? _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("更改密碼")]), _vm._v(" "), _c('h4', {
    staticClass: "hint"
  }, [_vm._v("密碼更改完成，您現在可使用新的密碼登入。")]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100px",
      "float": "right",
      "margin-top": "20px",
      "margin-bottom": "-20px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.returnLogin()
      }
    }
  }, [_vm._v("登入\n            ")])], 1)], 1) : _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("發生錯誤")]), _vm._v(" "), _c('h4', {
    staticClass: "hint"
  }, [_vm._v("連結已失效，如果還需要更改密碼，請點選下面更改密碼按鈕。")]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "width": "100px",
      "float": "right",
      "margin-top": "20px",
      "margin-bottom": "-20px"
    },
    attrs: {
      "type": "danger"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.returnForgetPwd()
      }
    }
  }, [_vm._v("更改密碼\n            ")])], 1)], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24cf84b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ForgetPWD.vue
// module id = 902
// module chunks = 170